import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateDataSavePhrase,
} from '@redux/conversation/converstationSlice'

export enum MessageType {
  text = 'text',
  audio = 'audio',
  board = 'board',
  score = 'score',
  image = 'image',
  select = 'selection',
  question = 'question',
  video = 'video',
  sentence = 'sentence',
  suggestionTable = 'suggestion_table',
  infoBoard = 'info_board',
  summary = 'summary',
}

export const processMessages = (rawMessages: any[]): any[] => {
  return rawMessages.reduce((acc: any[], curr: any) => {
    if (curr.message_type === 'audio') {
      const textMessage = acc.find(msg => msg.order === curr.order)
      if (textMessage) {
        textMessage.audio = curr.message
      }
      return acc
    }
    return [...acc, curr]
  }, [])
}

export const processProgress = (progress = []): any[] => {
  return progress.map((item: any) => {
    return item.progress_name
  })
}

const useConversationPage = () => {
  const conversationData = useSelector((state: any) => state.converstation)
  const { isOpenModalSaveKnowledge } = useSelector((state: any) => state.notebook)
  const [selectedTxtTrans, setSelectedTxtTrans] = useState<any>({})
  const dispatch = useDispatch<any>()

  const handleTextSelect = (e: any) => {
    const selection: any = window.getSelection()
    if (!selection || selection.rangeCount === 0) return null
    const range = selection.getRangeAt(0)
    const rect = range.getBoundingClientRect()
    const selectedText = selection.toString().trim()

    // Xử lý lấy index từ trong câu khi bôi đen cum từ
    if (!conversationData?.isDisableHandleText && !isOpenModalSaveKnowledge) {
      const sentencesAll = e.target.innerText
      let charactersIndex
      if (selection.anchorOffset < selection.focusOffset) {
        charactersIndex = selection.anchorOffset
      } else {
        charactersIndex = selection.focusOffset
      }
      const firstSentence = sentencesAll?.slice(0, charactersIndex)
      const wordIndex = firstSentence?.split(' ').length - 1
      const dataTextSelect = {
        phrase: selectedText,
        sentence: sentencesAll,
        index: wordIndex,
      }
      dispatch(updateDataSavePhrase(dataTextSelect))
    }

    if (!selectedText) return
    setSelectedTxtTrans({
      selectedText: selectedText,
      top: rect.top,
      left: rect.left + rect.width,
    })
  }

  return {
    selectedTxtTrans,
    handleTextSelect,
  }
}

export default useConversationPage
